import React from 'react';
import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

export const DetailInfoPrimary = styled.div`
  color: ${colors['near-black']};
  font-size: 14px;
`;

export const DetailInfoUserName = DetailInfoPrimary.extend`
  font-weight: bold;
`;

export const DetailInfoSecondary = styled.div`
  color: ${colors.N200};
  font-size: 12px;
`;

const DetailInfoDiv = styled.div`
  margin-left: 8px;
  min-width: 0;
  overflow-wrap: break-word;
  overflow: hidden;
  word-wrap: break-word;
`;

interface DetailInfoProps {
  name?: string;
  date?: string;
  children?: React.ReactNode;
}

export const DetailInfo = ({
  name,
  date,
  children,
  ...props
}: DetailInfoProps) => (
  <DetailInfoDiv {...props}>
    {name && <DetailInfoUserName>{name}</DetailInfoUserName>}
    {date && <DetailInfoSecondary>{date}</DetailInfoSecondary>}
    {children}
  </DetailInfoDiv>
);



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/DetailInfo.tsx